import { Gift, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { baseVoucherVisible, useBaseVoucher } from "@/components/BaseVoucherCard";
import { Button } from "@/components/ui/button";

const DISMISS_KEY = "rentri-suite:base-voucher-banner-dismissed";

/** Avviso non bloccante per i clienti Suite paganti: RENTRI Base in omaggio per il primo anno. */
export function BaseVoucherBanner() {
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem(DISMISS_KEY) === "1",
  );
  const voucherQ = useBaseVoucher(!dismissed);

  const v = voucherQ.data;
  if (dismissed || !baseVoucherVisible(v)) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-emerald-500/40 bg-emerald-500/15 px-4 py-2 text-sm">
      <span className="flex items-start gap-2">
        <Gift className="mt-0.5 h-4 w-4 shrink-0 text-emerald-700" />
        <span>
          Hai già RENTRI Suite: <strong>Mar.te RENTRI Base è in omaggio per te</strong> — risparmi{" "}
          <strong>{v.savings_label}</strong>. Conserva a norma i registri e gli xFIR prodotti sul portale
          RENTRI o con altri software prima del passaggio.
          {v.code ? " Il tuo buono è pronto." : ` Offerta valida fino al ${v.deadline}.`}
        </span>
      </span>
      <span className="flex items-center gap-1">
        <Button size="sm" variant="outline" onClick={() => navigate("/abbonamento#rentri-base")}>
          {v.code ? "Vedi il buono" : "Scopri l'offerta"}
        </Button>
        <Button size="icon" variant="ghost" className="h-8 w-8" onClick={dismiss} title="Nascondi">
          <X className="h-4 w-4" />
        </Button>
      </span>
    </div>
  );
}
